var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.48 13.2955C25.48 12.3737 25.3973 11.4873 25.2436 10.6364H13V15.665H19.9964C19.695 17.29 18.7791 18.6669 17.4023 19.5887V22.8505H21.6036C24.0618 20.5873 25.48 17.2546 25.48 13.2955Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0001 26C16.5101 26 19.4528 24.8359 21.6037 22.8504L17.4023 19.5886C16.2382 20.3686 14.7492 20.8295 13.0001 20.8295C9.61417 20.8295 6.74826 18.5427 5.72599 15.47H1.38281V18.8382C3.5219 23.0868 7.91826 26 13.0001 26Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7259 15.47C5.4659 14.69 5.31817 13.8568 5.31817 13C5.31817 12.1432 5.4659 11.31 5.7259 10.53V7.16183H1.38273C0.502272 8.91683 0 10.9023 0 13C0 15.0977 0.502272 17.0832 1.38273 18.8382L5.7259 15.47Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0001 5.17045C14.9087 5.17045 16.6223 5.82635 17.9696 7.11453L21.6982 3.3859C19.4469 1.28818 16.5042 0 13.0001 0C7.91826 0 3.5219 2.91318 1.38281 7.16181L5.72599 10.53C6.74826 7.45726 9.61416 5.17045 13.0001 5.17045Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.86cbe9a9ed8ae7338a567c0266efb0f0.svg";
export { ForwardRef as ReactComponent };